export const PLAN_GENERATION_TYPES = [
  { value: "BUSINESS_START", label: "Открытие бизнеса", subsidyAmount: 350000 },
  { value: "LPH", label: "ЛПХ", subsidyAmount: 200000 },
  { value: "TRAINING", label: "Обучение", subsidyAmount: 30000 },
];

export const DEFAULT_PLAN_GENERATION_TYPE = PLAN_GENERATION_TYPES[0].value;

export function getPlanGenerationTypeLabel(value) {
  return (
    PLAN_GENERATION_TYPES.find((item) => item.value === value)?.label ||
    PLAN_GENERATION_TYPES[0].label
  );
}
